<div class="text-center" *ngIf="loading">
  <ap-spinner size="3"></ap-spinner>
</div>
<div *ngIf="!loading">
  <div class="row">
    <div class="col-xs-12 messages-tab-title">
      <span class="h2">
        {{'Messages' | translate}}
        <span *ngIf="!isActiveDirectoryUser && unreadMessageCount && unreadMessageCount > 0" class="badge badge-danger">{{unreadMessageCount}}</span>
      </span>
      <span (click)="onExpandMessageCountsPanelClick()">
        <a class="message-counts-link">
          {{'Message Counts ' | translate}}
        </a>
      </span>
      <mat-icon id="{{Id}}-message-counts-link-icon-down" *ngIf="!isExpanded" class="material-icons clickable" (click)="onExpandMessageCountsPanelClick()">keyboard_arrow_down</mat-icon>
      <mat-icon id="{{Id}}-message-counts-link-icon-up" *ngIf="isExpanded" class="material-icons clickable" (click)="onExpandMessageCountsPanelClick()">keyboard_arrow_up</mat-icon>
    </div>
  </div>
  <div [collapse]="!isExpanded" [isAnimated]="true" id="collapseMessageCounts">
    <div class="text-center" *ngIf="loadingMessageCounts">
      <ap-spinner size="3"></ap-spinner>
    </div>
    <div class="row" *ngIf="!loadingMessageCounts">
      <div class="col-xs-12">
        <fp-message-counts [messageCounts]="messagesCountsResults" [messageUrgencies]="messagesUrgenciesResults"></fp-message-counts>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12">
      <hr>
    </div>
  </div>

  <!-- Tool Bar -->
  <div class="row" *ngIf="!isActiveDirectoryUser">
    <div class="col-xs-2">
      <!-- New message menu -->
      <div class="btn-group">
        <button id="{{Id}}-new-menu-button" type="button" class="btn btn-light btn-dropdown" mat-icon-button [matMenuTriggerFor]="createNewFacilityPortalMessage">
          {{'+ New'}}
        </button>
        <mat-menu #createNewFacilityPortalMessage = "matMenu">
          <button id="{{Id}}-new-menu-item-{{subType.Id}}" *ngFor="let subType of messageSubTypes; let i = index" (click)="onCreateNewMessageClick(subType)" mat-menu-item translate>{{subType.Name}}</button>
        </mat-menu>
      </div>
    </div>

    <div class="col-xs-2">
      <!-- Show Archived Checkbox -->
      <mat-checkbox id="{{Id}}-show-archived-checkbox" (change)="onShowArchivedChanged()" [(ngModel)]="showArchived" translate>Show Archived</mat-checkbox>
    </div>

    <div class="col-xs-5">
      <!-- Filter Find Control -->
      <div class="form-group">
        <ap-findcontrol [baseId]="Id + '-message-filter-find-control'"
                        [additionalSearchParameters]="messageFilterAdditionSearchParameters"
                        [findControlId]="findControlIdService.ListMessageSubType"
                        [(selectedPks)]="messageFilterSelected"
                        [placeHolder]="'Sub type'"
                        (selectedPksChange)="onMessageSubTypeSelected()"
                        [disabled]="false"
                        [singleSelect]="false">
        </ap-findcontrol>
      </div>
    </div>

    <div class="col-xs-3 icon-pull-right">
      <!-- material icon buttons -->
      <!--<a class="margin-left-15 mr-1" title="Sort" (click)="onSortClick()"><i id="{{Id}}-sort-button" class="material-icons md-24" title="Sort">sort</i></a>-->
      <a class="margin-left-15 mr-1" title="Refresh" (click)="onRefreshClick()"><i id="{{Id}}-refresh-button" class="material-icons md-24" title="Refresh">refresh</i></a>
      <!--<a class="margin-left-15" title="Menu" (click)="onMoreVertClick()"><i id="{{Id}}-menu-button" class="material-icons md-24" title="Menu">more_vert</i></a>-->
    </div>
  </div>

  <!-- Received Messages -->
  <div class="row">
    <div class="col-xs-12">
      <fp-messages-received [baseId]="Id"
        [messagesReceived]="messagesReceived"
        [loadingReceivedMessages]="loadingReceivedMessages"
        [showArchived]="showArchived"
        [readOnly]="isActiveDirectoryUser"
        (reload)="reload($event)"
      ></fp-messages-received>
      <ngx-toasta></ngx-toasta>
    </div>
  </div>
</div>
